module.exports = __webpack_public_path__ + "85601455d3b2a765003ef1a1f3865c7a.MP3";